import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
//import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';


import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule, DxTreeViewModule, DxDropDownBoxModule, DxTreeViewComponent } from 'devextreme-angular';


import { AccionEspecificaService } from '../../../services/formulacion/accion-especifica.service';
import { IndicadorService } from '../../../services/formulacion/indicador.service';
import { RiesgoService } from '../../../services/formulacion/riesgo.service';
import { OperacionService } from '../../../services/formulacion/operacion.service';
import { PartidaPresService } from '../../../services/formulacion/partida-pres.service';
import { UnidadMedidaService } from '../../../services/formulacion/unidad-medida.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { fail } from 'assert';
import { AccionCortoPlazoService, IndicadorProgramacionService, RevisionOperacionODSService } from '../../../services/service.index';

declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-list-formulacion',
  templateUrl: './list-formulacion.component.html',
  styleUrls: [],
  providers: [AccionEspecificaService, OperacionService, IndicadorService, PartidaPresService, UnidadMedidaService, RiesgoService]
})
export class ListFormulacionComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;
  popupVisibleIndicadorAE: boolean = false;
  popupVisibleIndicadorOP: boolean = false;
  idAE: number = 0;
  datasourceIndicadorP: any[];
  datasourceIndicadorAcp: any[];
  indicadoresOP: any = [];
  rol: number = 0;
  excedeTotal: boolean = false;
  lsMeses: any = [];
  lsIndicadoresMes: any = [];
  lsIndicadoresAcpMes: any = [];
  insert: boolean = true;
  aux: boolean = false;
  detalle: any = {};
  editDetalle: boolean = false;
  clicked: boolean = false;
  modelProgramacion: any = {
    id: 0,
    variable1: '',
    variable2: '',
    indicador_id: 0,
    meta: '',
    meses: [],
  }

  modelProgramacionAcp: any = {
    id: 0,
    variable1: '',
    variable2: '',
    indicador_id: 0,
    meta: '',
    meses: [],
  }

  scrollByContent = true;
  scrollByThumb = true;
  poaTecho: any;
  dataResourceAE: any[];
  popupVisibleOP: boolean = false;
  popupVisibleAE: boolean = false;
  popupVisibleDelRAP: boolean = false;
  popupVisibleDelAE: boolean = false;
  popupVisibleEditAE: boolean = false;
  popupVisibleEditI: boolean = false;
  popupVisibleAddI: boolean = false;
  popupVisibleDelI: boolean = false;
  popupVisibleEditO: boolean = false;
  popupVisibleDelO: boolean = false;
  popupVisibleDelIO: boolean = false;
  popupVisibleAddRA: boolean = false;
  popupVisibleAddPL: boolean = false;
  popupVisibleP: boolean = false;
  popupVisibleIAcp: boolean = false;
  
  popupVisibleAddODS: boolean = false;
  popupVisibleDelODS: boolean = false;
  rev_ods_poa: any = { id: 0, codigo_ods: '', codigo_operacion: '', operacion_id: '', acp_id: '', estado_ods: '', ods_id: '', psdi_id: '' };
  id_revision_ods: number = 0;
  ods_descripcion: string = '';
  psdi_descripcion: string = '';
  indicadores_ods: any[];
  indicadores_psdi: any[];
  totalProgramado: number = 0;
  totalrestante: number = 0;

  techoId: string;
  model: any = { indicadoresPlan: [], };
  variable: any = { id: 0, indicador_id: 0, estado: '' };
  variable1 = false;
  variable2 = false;
  item: any = {};
  indicadoresId: number = 1;
  operacionesId: number = 1;
  operacion: any;
  indicadores: any = [];
  operaciones: any = [];
  accionEspecifica: any = {};
  dpartida: string = '';
  total = '0';
  riesgoAccionId: number;
  AEId: number;
  OPId: number;
  AEDescripcion: string;
  delIndicadorId: number;
  delOperacionId: number;
  delIndicadorO: number;
  idIndicador: number;
  idIndicadorAcp: number;
  gestionPOA: string;
  OpDescripcion: string;
  modelRA: any = { indicador_id: 0, riesgo: '', accion_preventiva: '' };
  modelPL: any = { operacion_id: 0, ponderacion: 0, descripcion: '', meta: 0, linea_base: 0 };
  tipo_indicador_id = [{ text: 'Frecuencia', value: 1 }, { text: 'Avance', value: 2 }];
  hasError: any;
  soloLectura: boolean = false;
  idUser: number = 0;
  contadorAE: number = 0;
  datasourceAcp: any[];
  constructor(private route: ActivatedRoute, private router: Router, private _ae: AccionEspecificaService, private _os: OperacionService, private _is: IndicadorService, private _ps: PartidaPresService, private _us: UnidadMedidaService, private _gs: GeneralService, private _rs: RiesgoService, private _iop: IndicadorProgramacionService,
    private _srev: RevisionOperacionODSService, private _acps: AccionCortoPlazoService,) {
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.techoId = params.get('id'))).subscribe();
    this.poaTecho = {
      'descripcion_techo': '',
      'techo_unidad_organizacional': '',
      'techo_categoria_programatica': '',
      'techo_tipo_gasto': '',
      'techo_tipo_intervencion': '',
      'techo_gestion': ''
    };
    this.getPoaTecho();
    this.resetErrors();
    this.gestionPOA = JSON.parse(localStorage.getItem('g'));

    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
    this.idUser = u.id;


  }

  ngOnInit() {
    this.getAccionEspecifica();
    this.getAccionCortoPlazo();
  }

  ngAfterViewInit() {
    jQuery('.sel2').select2();
  }

  getAccionEspecifica() {
    this._ae.getListAccionEspecifica(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.dataResourceAE = result.data;
          if (this.dataResourceAE != null)
            this.contadorAE = result.data.length;
        } else {
          this.dataResourceAE = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getPoaTecho() {
    this._gs.getPoaTechoById(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.poaTecho = result.data;
          if (parseInt(this.techoId) <= 946)
            this.soloLectura = true;
        } else {
          this.poaTecho = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  showModalAddAE() {
    if (this.dataResourceAE == null) {
      this.clearAccionEspecifica();
      this.resetErrors();
      this.getListODS();
      this.getListPSDI();
      this.popupVisibleAE = true;
      this.AEId = 0;
    } else {
      toastr.info('No se puede registrar más de un Resultado de Gestión...');
    }
  }

  showModalEditAE(accion_esp_id: number, revision_id: string, ods_id: string, psdi_id: string, acp_id: number) {
    this.resetErrors();
    this.getListODS();
    this.getListPSDI();
    this.getAccionEspecificaById(accion_esp_id);
    this.AEId = accion_esp_id;


    this.model.acp_id = acp_id;
    this.getIndicadoresRegistrados(accion_esp_id);
    if (acp_id != null) {

      this.getIndicadorProceso(this.model.acp_id);
    }


    this.model.revision_id = accion_esp_id;
    if (revision_id != '') {
      this.model.psdi_id = psdi_id;
      this.model.ods_id = ods_id;
      this.rev_ods_poa.ods_id = ods_id;
      this.rev_ods_poa.psdi_id = psdi_id;
    }
    else {
      this.rev_ods_poa.ods_id = '';
      this.rev_ods_poa.psdi_id = '';
      this.ods_descripcion = '';
      this.psdi_descripcion = '';
    }
    this.popupVisibleEditAE = true;
  }

  showModalEditI(accion_esp_id: number) {
    //this.getAccionEspecificaById(accion_esp_id);
    this.getPoaIndicadoresAccionEspecifica(accion_esp_id);
    this.popupVisibleEditI = true;
  }

  showModalAddIndicador(id: number, ae: string) {
    this.AEId = id;
    this.AEDescripcion = ae;
    this.indicadores = [{ id: 1, descripcion: '', meta: '', linea_base: '', riesgo_accion: [{ id: 1, riesgo: '', accion_preventiva: '' }] }];
    this.popupVisibleAddI = true;
  }

  showModalAddIClose() {

    this.getPoaIndicadoresAccionEspecifica(this.AEId);
    this.popupVisibleAddI = false;
  }

  showModalAddOP(accion_esp_id: number) {
    this.AEId = accion_esp_id;
    this.getAccionEspecificaById(accion_esp_id);
    this.popupVisibleOP = true;
  }

  showModalEditOP(operacion_id: number) {
    this.OPId = operacion_id;
    this.getIndicadoresByIdOperacion(operacion_id);
    this.popupVisibleEditO = true;
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  
  addIndicador() {
    this.indicadoresId++;
    this.indicadores.push({
      id: this.indicadoresId,
      descripcion: '',
      meta: '',
      linea_base: '',
      riesgo_accion: [
        { id: 1, riesgo: '', accion_preventiva: '' }
      ]
    });
  }

  addRiesgoAccion(id: number) {
    for (var i = 0; i < this.indicadores.length; i++) {
      if (this.indicadores[i].id == id) {
        let id = this.indicadores[i].riesgo_accion.length + 1;
        this.indicadores[i].riesgo_accion.push({ id: id, riesgo: '', accion_preventiva: '' });
        break;
      }
    }
  }

  removeIndicador(id: number) {
    for (var i = 0; i < this.indicadores.length; i++) {
      if (this.indicadores[i].id == id) {
        this.indicadores.splice(i, 1);
        break;
      }
    }
  }

  removeRiesgoAccion(id: number, idIndicador: number) {
    for (var i = 0; i < this.indicadores.length; i++) {
      if (this.indicadores[i].id == idIndicador) {
        for (var j = 0; j < this.indicadores[i].riesgo_accion.length; j++) {
          if (this.indicadores[i].riesgo_accion[j].id == id) {
            this.indicadores[i].riesgo_accion.splice(j, 1);
            break;
          }
        }
        break;
      }
    }
  }

  addOperacion() {

    this.operacionesId++;
    this.operaciones.push({
      id: this.operacionesId,
      descripcion: '',
      ponderacion: '',
      revision: [{ codigo_ods: '', codigo_psdi: '' }],
      indicador_meta: [
        { id: 1, ponderacion: '', descripcion: '', meta: '', linea_base: '' }
      ]
    });
  }

  addOperacionIndicador() {
    this.indicadoresId = 1;
    this.indicadoresId++;
    this.indicadoresOP.push({
      id: this.indicadoresId, ponderacion: '', descripcion: '', meta: '', linea_base: '', medio_verificacion: '', tipo_indicador_id: '', unidad_medida: ''
    });
  }

  removeOperacion(id: number) {
    for (var i = 0; i < this.operaciones.length; i++) {
      if (this.operaciones[i].id == id) {
        this.operaciones.splice(i, 1);
        break;
      }
    }
  }

  removeOperacionIndicador(id: number, idOperacion: number) {
    for (var i = 0; i < this.indicadoresOP.length; i++) {
      if (this.indicadoresOP[i].id == id) {
        this.indicadoresOP.splice(i, 1);
        break;
      }
    }
  }

  saveAccionEspecificaIndicadores() {
    this.resetErrors();

    if (this.validSaveAE()) {

      this.clicked = true;
      let data = { techo_id: this.techoId, id: this.model.id, descripcion: this.model.accionEspecifica, indicadores: this.indicadores, problema: this.model.problema, acp_id: this.model.acp_id, revision_id: this.model.revision_id, ods_id: this.model.ods_id, psdi_id: this.model.psdi_id, indicadoresPlan: this.model.indicadoresPlan };

      if (this.model.id == 0) {
        this._ae.postAccionEspecifica(data).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            this.clicked = false;
            if (result.status == 200) {
              this.clicked = false;
              this.popupVisibleAE = false; this.refreshDataGrid();
              toastr.success('Datos guardados exitosamente.');
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }

  updateAccionEspecifica() {
    this.resetErrors();
    if (this.validSaveAE()) {

      this._ae.putAccionEspecifica({ id: this.model.id, descripcion: this.model.accionEspecifica, problema: this.model.problema, acp_id: this.model.acp_id, resultado_gestion: this.model.resultado_gestion, revision_id: this.model.revision_id, ods_id: this.model.ods_id, psdi_id: this.model.psdi_id, indicadoresPlan: this.model.indicadoresPlan }).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.popupVisibleEditAE = false; this.refreshDataGrid();
            toastr.success('Datos actualizados exitosamente.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  saveAccionEspecificaOperacion() {
    let data = { accion_especifica_id: this.AEId, operaciones: this.operaciones };
    if (this.validPonderacionPonderacion()) {
      this.clicked = true;
      this._ae.postAccionEspecificaOperaciones(data).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.clicked = false;
            this.popupVisibleOP = false;
            this.getAccionEspecificaById(this.AEId);
            toastr.success('Operaciones creadas exitosamente.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  saveIndicadoresOP() {
    let data = { operacion_id: this.OPId, indicadores: this.indicadoresOP };
    this.clicked = true;
    if (this.validIndicadores()) {
      this._ae.postOperacionIndicadores(data).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.clicked = false;
            this.getAccionEspecificaById(this.idAE);
            this.popupVisibleEditO = false;

            toastr.success('Indicadores registrados exitosamente.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getIndicadoresByIdOperacion(id: number) {
    this._ae.getListIndicadoresByOperacionId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.operacion = result.data.descripcion;
          this.indicadoresOP = result.data.indicadores;
        }
        if (result.data.indicadores.length == 0) {
          this.addOperacionIndicador();
        }
      },
      (error) => { console.log('Error', error); });
  }

  getAccionEspecificaById(id: number) {
    this._ae.getAccionEspecificaById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.model.id = result.data.id;
          this.model.accionEspecifica = result.data.descripcion;
          this.model.resultado_gestion = result.data.resultado_gestion;
          this.model.problema = result.data.problema;
          this.indicadores = result.data.indicadores;
          this.operaciones = result.data.operaciones;

        }
        if (result.data.operaciones.length == 0) {
          this.addOperacion();
        }
      },
      (error) => { console.log('Error', error); });
  }

  validPonderacion() {
    let t = 0, ti = 0, f = false, r = true, f2 = false;
    this.operaciones.forEach(item => {
      t += item.ponderacion != '' ? parseInt(item.ponderacion) : 0;
      ti = 0;
      item.indicador_meta.forEach(item1 => {
        ti += item1.ponderacion != '' ? parseInt(item1.ponderacion) : 0;
        if (ti > 100) f = true;
      });
      if (ti != 100) f2 = true;
    });
    if (t > 100) {
      toastr.warning('Sobrepasó el 100% de la ponderación de las Operaciones');
      r = false;
    }
    else {
      if (t != 100) {
        toastr.warning('La suma de las ponderaciones de las Operaciones debe ser igual a 100%');
        r = false;
      }
    }
    if (f) {
      toastr.warning('Sobrepasó el 100% en la ponderación de algún Indicador Meta');
      r = false;
    }
    else {
      if (f2) {
        toastr.warning('La suma de las ponderaciones en los Indicadores Meta debe ser igual a 100%');
        r = false;
      }
    }
    return r;
  }

  validPonderacionPonderacion() {
    let t = 0, ti = 0, f = false, r = true, f2 = false, f3 = false;
    this.operaciones.forEach(item => {
      if ((item.ponderacion == '') || (item.descripcion == ''))
        f3 = true;
      t += item.ponderacion != '' ? parseInt(item.ponderacion) : 0;
    });
    if (f3) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    if (t > 100) {
      toastr.warning('Sobrepasó el 100% de la ponderación de las Operaciones');
      r = false;
    }
    else {
      if (t != 100) {
        toastr.warning('La suma de las ponderaciones de las Operaciones debe ser igual a 100%');
        r = false;
      }
    }
    return r;
  }

  validIndicadores() {
    let t = 0, ti = 0, f = false, r = true, f2 = false, f3 = false;
    this.indicadoresOP.forEach(item1 => {
      if ((item1.ponderacion == '') || (item1.ponderacion == null) || (item1.descripcion == '') || (item1.descripcion == null) || (item1.meta == '') || (item1.meta == null) || (item1.medio_verificacion == '') || (item1.medio_verificacion == null))
        f3 = true;
      ti += item1.ponderacion != '' ? parseInt(item1.ponderacion) : 0;
      if (ti > 100) f = true;
    });
    if (f3) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    if (ti != 100) f2 = true;
    if (f) {
      toastr.warning('Sobrepasó el 100% en la ponderación de algún Indicador Meta');
      r = false;
    }
    else {
      if (f2) {
        toastr.warning('La suma de las ponderaciones en los Indicadores Meta debe ser igual a 100%');
        r = false;
      }
    }
    return r;
  }

  clearAccionEspecifica() {
    this.model = { id: 0, accionEspecifica: '' };
    this.indicadoresId = 1;
    this.operacionesId = 1;
    this.indicadores = [{
      id: 1,
      descripcion: '',
      meta: '',
      linea_base: '',
      riesgo_accion: [
        { id: 1, riesgo: '', accion_preventiva: '' }
      ]
    }];
    this.operaciones = [{
      id: 1,
      descripcion: '',
      ponderacion: '',
      indicador_meta: [
        { id: 1, ponderacion: '', descripcion: '', meta: '', linea_base: '' }
      ]
    }];
  }

  refreshDataGrid() {
    this.getAccionEspecifica();
    this.dataGrid.instance.refresh();
  }

  onlyNumbersInt(e: any) {
    UtilHelper.onlyNumbersInt(e);
  }

  linkTareas(aid: number) {
    this.router.navigate(['/formulario/tarea/', this.techoId, aid]);
    //[routerLink]="['/formulario/tarea/', techoId, data.data.id]"
  }

  deleteRiesgoAccion(id: number) {
    this.popupVisibleDelRAP = true;
    this.riesgoAccionId = id;
  }

  deleteRiesgoAP() {
    this.popupVisibleDelRAP = false;
    this._rs.deleteRiego(this.riesgoAccionId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getPoaIndicadoresAccionEspecifica(this.idAE);
          //this.refreshDataGrid();
          this.popupVisibleDelRAP = false;
          //this.popupVisibleEditI = false;
          toastr.success('Operación realizada exitosamente.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  resetErrors() {
    this.hasError = { problema: false, ae: false, variable1: false, variable2: false, ods_id: false, psdi_id: false, acp_id: false, indicadoresPlan: false };
  }

  validSaveAE() {
    let res = true;
    if (!UtilHelper.validator(this.model.accionEspecifica, 'text')) {
      this.hasError.ae = true; res = false;
    }
    if (!UtilHelper.validator(this.model.problema, 'text') || (this.model.problema == null)) {
      this.hasError.problema = true; res = false;
    }
    if (!UtilHelper.validator(this.model.resultado_gestion, 'text')) {
      this.hasError.resultado_gestion = true; res = false;
    }
    if (!UtilHelper.validator(this.model.ods_id, 'integer')) {
      this.hasError.ods_id = true; res = false;
    }
    if (!UtilHelper.validator(this.model.psdi_id, 'integer')) {
      this.hasError.psdi_id = true; res = false;
    }
    if (this.rol == 23 && this.gestionPOA >= '2025') {
      if (!UtilHelper.validator(this.model.acp_id, 'integer')) {
        this.hasError.acp_id = true; res = false;
      }
    }

    if (this.AEId != 0) {
      if (this.rol == 23 && this.gestionPOA >= '2025' && (this.datasourceIndicadorAcp.length == 0)) {
        if (!UtilHelper.validator(this.model.indicadoresPlan, 'integer')) {
          this.hasError.indicadoresPlan = true; res = false;
        }
      }
    }

    return res;
  }

  showModalDeleteAE(id: number) {
    this.popupVisibleDelAE = true;
    this.AEId = id;
  }

  deleteAE() {
    this._ae.deleteAccionEspecifica(this.AEId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {

          this.contadorAE = 0;
          this.getAccionEspecifica();
          this.refreshDataGrid();
          this.popupVisibleDelAE = false;
          toastr.success('Acción Específica eliminada exitosamente.');
        }
        else if (result.status == 201) {
          toastr.warning('No es posible eliminar la Acción Específica, debido a que tiene indicadores u operaciones asociadas.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al borrar la Acción Específica.');
        }
      },
      error => { console.log('Error', error); });
  }

  updateIndicador(id: number) {
    let i = this.indicadores.filter(o => o.id == id).map(o => o)[0];
    this._is.putIndicador(i).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleEditI = false; this.refreshDataGrid();
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  updateRiesgoAccion(idi: number, id: number) {
    let i = this.indicadores.filter(o => o.id == idi).map(o => o)[0];
    let ra = i.riesgo_accion.filter(o => o.id == id).map(o => o)[0];
    this._rs.putRiesgo(ra).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getAccionEspecificaById(this.idAE);
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  saveIndicador() {
    this.clicked = true;
    let i = this.indicadores[0];
    this._is.postIndicadorRiesgos({ accion_especifica_id: this.AEId, descripcion: i.descripcion, meta: i.meta, linea_base: i.linea_base, riesgos: i.riesgo_accion }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.clicked = false;
          this.getPoaIndicadoresAccionEspecifica(this.idAE);
          this.popupVisibleAddI = false;
          toastr.success('Datos guardados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalDeleteInd(id: number) {

    this.popupVisibleDelI = true;
    this.delIndicadorId = id;

  }

  deleteIndicadorAcp() {

    this._is.deleteIndicador(this.delIndicadorId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getPoaIndicadoresAccionEspecifica(this.idAE);
          this.refreshDataGrid();
          this.popupVisibleDelI = false;
          //this.popupVisibleEditI = false;
          toastr.success('Indicador eliminado exitosamente.');
        }
        else if (result.status == 201) {
          toastr.warning('No es posible eliminar el Indicador, debido a que tiene elementos asociados.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al borrar el Indicador.');
        }
      },
      error => { console.log('Error', error); });
  }

  updateOperacion(id: number) {
    if (this.validPonderacion()) {
      let o = this.operaciones.filter(o => o.id == id).map(o => o)[0];
      this._os.putOperacion(o).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            //this.popupVisibleEditO = false; 
            this.refreshDataGrid();
            toastr.success('Datos actualizados exitosamente.');
          }
          else if (result.status == 210) {
            toastr.success('No es posible modificar los datos debido a que existen registros de ejecución.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalDeleteOperacion(id: number) {
    this.popupVisibleDelO = true;
    this.delOperacionId = id;
  }

  deleteOperacion() {
    this._os.deleteOperacion(this.delOperacionId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getAccionEspecificaById(this.AEId);
          this.refreshDataGrid();
          this.popupVisibleDelO = false;
          toastr.success('Operación eliminada exitosamente.');
        }
        else if (result.status == 201) {
          toastr.warning('No es posible eliminar la Operación, debido a que tiene Indicadores y/o Tareas asociadas.');
        }
        else if (result.status == 210) {
          toastr.success('No es posible eliminar la Operación debido a que existen registros de ejecución.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al borrar la Operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  showModalDeleteIndicadorO(id: number) {
    this.popupVisibleDelIO = true;
    this.delIndicadorO = id;
  }

  deleteIndicadorO() {
    this.popupVisibleDelIO = false;
    this._os.deleteIndicadorOperacion(this.delIndicadorO).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getIndicadoresByIdOperacion(this.OPId);
          this.popupVisibleDelIO = false;
          toastr.success('Operación realizada exitosamente.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }

  updateIndicadorO(ido: number, id: number) {
    if (this.validPonderacion()) {
      let o = this.operaciones.filter(o => o.id == ido).map(o => o)[0];
      let im = o.indicador_meta.filter(o => o.id == id).map(o => o)[0];
      this._os.putIndicadorOperacion(im).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            //this.popupVisibleEditO = false; 
            this.getPoaIndicadoresAccionEspecifica(this.idAE);
            toastr.success('Datos actualizados exitosamente.');
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalAddRA(id: number) {
    this.popupVisibleAddRA = true;
    this.modelRA = { indicador_id: id, riesgo: '', accion_preventiva: '' };
  }

  addRAIndicador() {
    this._rs.postAddRiesgo(this.modelRA).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleAddRA = false;
          this.popupVisibleEditI = false; this.refreshDataGrid();
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalAddPL(id: number) {
    this.popupVisibleAddPL = true;
    this.modelPL = { operacion_id: id, ponderacion: 0, descripcion: '', meta: 0, linea_base: 0 };
  }

  addPLOperacion() {
    this._os.postIndicadorOperacion(this.modelPL).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleAddPL = false;
          this.popupVisibleEditO = false; this.refreshDataGrid();
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }


  showModalProgramacion(id: number, meta: number, ind: string, op: string) {
    this.resetErrors();
    this.variable1 = false;
    this.variable2 = false;
    this.idIndicador = id;
    this.modelProgramacion.meta = meta;
    this.OpDescripcion = op;
    this.cargarIndicadorMesPorIndicador();
    this.modelProgramacion.variable1 = ind;
    this.popupVisibleP = true;
  }

  showModalProgramacionAcp(id: number, meta: number, ind: string) {
    this.resetErrors();
    this.variable1 = false;
    this.variable2 = false;
    this.idIndicadorAcp = id;
    this.modelProgramacionAcp.meta = meta;
    this.cargarIndicadorAcpMesPorIndicador();
    this.modelProgramacionAcp.variable1 = ind;
    this.popupVisibleIAcp = true;
  }

  deleteProgramacion(id: number) {
    this._os.deleteProgramacion(id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.refreshDataGrid();
          this.getAccionEspecificaById(this.idAE);
          toastr.success('Operación realizada exitosamente.');
        }
        else {
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });
  }

  deleteProgramacionAcp(id: number) {

    this._os.deleteProgramacionAcp(id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.refreshDataGrid();
          this.getPoaIndicadoresAccionEspecifica(this.idAE);
          toastr.success('Operación realizada exitosamente.');
        }
        else {
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });
  }

  saveProgramacion() {
    this.resetErrors();
    if (this.validIndicadoresMes()) {
      if (this.insert == true) {
        this.clicked = true;
        this.modelProgramacion.meses = this.lsIndicadoresMes;
        this.modelProgramacion.indicador_id = this.idIndicador;
        this._iop.postIndicadorMes(this.modelProgramacion).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getAccionEspecificaById(this.idAE);
              this.popupVisibleP = false;
              this.clicked = false;
              toastr.success('Datos guardados exitosamente.');
            }
          },
          (error) => { console.log('Error', error); });
      }
      else {
        this.modelProgramacion.meses = this.lsIndicadoresMes;
        this.modelProgramacion.indicador_id = this.idIndicador;
        this._iop.putIndicadorMes(this.modelProgramacion).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.popupVisibleP = false;
              this.clicked = false;
              toastr.success('Datos actualizados exitosamente.');
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }

  saveProgramacionAcp() {
    this.resetErrors();
    if (this.validIndicadoresMesAcp()) {
      if (this.insert == true) {
        this.clicked = true;
        this.modelProgramacionAcp.meses = this.lsIndicadoresAcpMes;
        this.modelProgramacionAcp.indicador_id = this.idIndicadorAcp;
        this._iop.postIndicadorMesAcp(this.modelProgramacionAcp).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getPoaIndicadoresAccionEspecifica(this.idAE);
              this.popupVisibleIAcp = false;
              this.clicked = false;
              toastr.success('Datos guardados exitosamente.');
            }
          },
          (error) => { console.log('Error', error); });
      }
      else {
        this.modelProgramacionAcp.meses = this.lsIndicadoresAcpMes;
        this.modelProgramacionAcp.indicador_id = this.idIndicadorAcp;
        this._iop.putIndicadorMesAcp(this.modelProgramacionAcp).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getPoaIndicadoresAccionEspecifica(this.idAE);
              this.popupVisibleIAcp = false;
              this.clicked = false;
              toastr.success('Datos actualizados exitosamente.');
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }

  cargarIndicadorMesPorIndicador() {
    this._iop.getListIndicadoresMesPorIndicador(this.idIndicador)
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.lsIndicadoresMes = result.data;
            this.insert = false;
            this.getListSoloMeses();
            this.aux = false;
          }
          if (result.status == 201) {
            this.insert = true;
            this.getListMeses();
            this.aux = true;
          }
        },
        (error) => { console.log('Error', error); });
  }

  cargarIndicadorAcpMesPorIndicador() {
    this._iop.getListIndicadoresAcpMesPorIndicador(this.idIndicadorAcp)
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.lsIndicadoresAcpMes = result.data;
            this.insert = false;
            this.getListSoloMeses();
            this.aux = false;
          }
          if (result.status == 201) {
            this.insert = true;
            this.getListMesesAcp();
            this.aux = true;
          }
        },
        (error) => { console.log('Error', error); });
  }

  validIndicadoresMes() {
    let r = true, f1 = false, f2 = false, total = 0;
    this.lsIndicadoresMes.forEach(item => {
      if (item.valor_indicador == '')
        item.valor_indicador = 0;
      total = total + parseFloat(item.valor_indicador);
      if ((item.valor_indicador < 0) && (item.valor_indicador != 0))
        f1 = true;
    });

    if ((total.toFixed(2) != this.modelProgramacion.meta)) {
      f2 = true;
    }
    if (f1) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    if ((f2)) {
      r = false;
      toastr.warning('Los datos deben ser igual a la meta programada...');
    }
    return r;
  }

  validIndicadoresMesAcp() {
    let r = true, f1 = false, f2 = false, total = 0;
    this.lsIndicadoresAcpMes.forEach(item => {
      if (item.valor_indicador == '')
        item.valor_indicador = 0;
      total = total + parseFloat(item.valor_indicador);
      if ((item.valor_indicador < 0) && (item.valor_indicador != 0))
        f1 = true;
    });

    if ((total.toFixed(2) != this.modelProgramacionAcp.meta)) {
      f2 = true;
    }
    if (f1) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    if ((f2)) {
      r = false;
      toastr.warning('Los datos deben ser igual a la meta programada...');
    }
    return r;
  }

  getListMeses() {
    this._iop.getListMeses()
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.lsMeses = result.data;
            if (this.insert == true) {
              this.lsIndicadoresMes = [];
              for (var _i = 0; _i < this.lsMeses.length; _i++) {
                var item = this.lsMeses[_i];
                let id = this.lsMeses.length + 1;
                this.lsIndicadoresMes.push({ id: _i, valor_indicador: '', mes_id: this.lsMeses[_i].id, mes: this.lsMeses[_i].mes });
              }
            }
          }
        },
        (error) => { console.log('Error', error); });
  }

  getListMesesAcp() {
    this._iop.getListMeses()
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.lsMeses = result.data;
            if (this.insert == true) {
              this.lsIndicadoresAcpMes = [];
              for (var _i = 0; _i < this.lsMeses.length; _i++) {
                var item = this.lsMeses[_i];
                let id = this.lsMeses.length + 1;
                this.lsIndicadoresAcpMes.push({ id: _i, valor_indicador: '', mes_id: this.lsMeses[_i].id, mes: this.lsMeses[_i].mes });
              }
            }
          }
        },
        (error) => { console.log('Error', error); });
  }

  getListSoloMeses() {
    this._iop.getListMeses()
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.lsMeses = result.data;
          }
        },
        (error) => { console.log('Error', error); });
  }

  sugerirProgramacion() {
    for (var _i = 0; _i < this.lsIndicadoresMes.length; _i++) {
      var itemIndicadorMes = this.lsIndicadoresMes[_i];
      var valorInicial = this.modelProgramacion.meta / 12;
      itemIndicadorMes.valor_indicador = + valorInicial.toFixed(2);
    }
  }

  showModalIndicadorAE(id: number, ae: string) {
    this.AEDescripcion = ae;
    this.idAE = id;
    this.getPoaIndicadoresAccionEspecifica(this.idAE);
    this.popupVisibleIndicadorAE = true;
  }

  getPoaIndicadoresAccionEspecifica(id: number) {
    this._is.getPoaIndicadoresAccionEspecifica(id)
      .subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.indicadores = result.data;
          }
          else {
            this.indicadores = [];
          }
        },
        (error) => { console.log('Error', error); });
  }
  showModalOperaciones(id: number) {
    this.idAE = id;
    this.getAccionEspecificaById(id);
    this.popupVisibleIndicadorOP = true;

  }

  /* metodos para ODS*/

  showModalAddODS(rev: any) {
    this.getListODS();
    this.getListPSDI();
    this.operacion = rev.descripcion;
    this.rev_ods_poa.operacion_id = rev.id;
    if (rev.revision.operacion_id != 0) {
      this.rev_ods_poa.acp_id = rev.id;
      this.rev_ods_poa.ods_id = rev.revision.ods_id;
      this.rev_ods_poa.psdi_id = rev.revision.psdi_id;
    }
    else {
      this.rev_ods_poa.ods_id = '';
      this.rev_ods_poa.psdi_id = '';
      this.ods_descripcion = '';
      this.psdi_descripcion = '';
    }
    this.popupVisibleAddODS = true;
  }


  getIndicadoresODS() {

  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.ods_id, 'integer')) {
      this.hasError.ods_id = true; res = false;
    }
    if (!UtilHelper.validator(data.psdi_id, 'integer')) {
      this.hasError.psdi_id = true; res = false;
    }
    return res;
  }
  registrarRevision() {
    if (this.validate(this.rev_ods_poa)) {
      this._srev.postRevisionOperacionODS(this.rev_ods_poa).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getAccionEspecificaById(this.idAE);
            this.popupVisibleAddODS = false;
            toastr.success('Articulado exitosamente.');
          } else {
            toastr.warning(result.data);
          }
        },
        error => { console.log('Error', error); });


    }
  }

  showModalDelete(id: number) {
    this.id_revision_ods = id;
    this.popupVisibleDelODS = true;
  }

  getDisplayCod(item) {
    if (!item) {
      return '';
    }

    return `${item.codigo} ${item.descripcion}`;
  }

  getDisplayOds(item) {
    if (!item) {
      return '';
    }

    return `${item.codigo} ${item.descripcion}`;
  }

  getListODS() {
    this._srev.getListODS().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.indicadores_ods = result.data;
        }
        else {
          this.indicadores_ods = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  getODSbyId(e: any) {
    this.indicadores_ods.forEach(item => {
      if (item.id == e.value) {
        this.ods_descripcion = item.descripcion;
        this.model.ods_id = item.id;
      }
    });
  }

  getListPSDI() {
    this._srev.getListPSDI().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.indicadores_psdi = result.data;
        }
        else {
          this.indicadores_ods = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  getPSDIbyId(e: any) {

    this.indicadores_psdi.forEach(item => {
      if (item.id == e.value) {
        this.psdi_descripcion = item.descripcion;
        this.model.psdi_id = e.value;
      }
    });
  }

  /* fin metodo para ODS */

  getAccionCortoPlazo() {
    this._acps.getAccionCortoPlazo().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {

          this.datasourceAcp = result.data;

        } else {
          this.datasourceAcp = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  getIndicadorProceso(id: number) {

    if (id != 0) {
      this._acps.getIndicadorProcesoByAeiId(id).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.datasourceIndicadorP = result.data;
          } else {
            this.datasourceIndicadorP = [];
          }
        },
        error => {
          console.log('Error', error);
        });
    }
  }


  getIndicadoresId(e: any) {

    this.getIndicadorProceso(e.value);
  }


  getDisplay(item) {
    if (!item) {
      return '';
    }

    return `${item.indicador_pdes}`;
  }

  getIndicadoresRegistrados(id: number) {

    this._acps.getIndicadoresRegistradosbyIdAcp(id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.datasourceIndicadorAcp = result.data;

        } else {
          this.datasourceIndicadorAcp = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }


  deleteIndicador(id: number) {
    this._acps.deleteIndicadorAei(id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getIndicadoresRegistrados(this.model.id);
          toastr.success('Proceso realizado correctamente.');
        } else {
          toastr.warning(result.data);
        }
      },
      (error) => { console.log('Error', error); });
  }

  calculaTotalFuente(id) {


    this.excedeTotal = false;
    let f = this.lsIndicadoresMes.filter(o => o.id == id).map(o => o)[0];

    let tt = 0;
    for (var i = 0; i < this.lsIndicadoresMes.length; i++) {
    
      tt += parseFloat(this.lsIndicadoresMes[i].valor_indicador);

    }

    this.totalProgramado = tt;
    this.totalrestante = this.modelProgramacion.meta - this.totalProgramado;


  
  }

}
